// Generate a unique device identifier
export function getDeviceId() {
  const storageKey = 'gigrequest_device_id';
  
  // Check if we already have one
  let deviceId = localStorage.getItem(storageKey);
  
  if (deviceId) {
    return deviceId;
  }
  
  // Generate new UUID-like ID
  deviceId = 'device_' + generateUUID();
  
  // Store it
  localStorage.setItem(storageKey, deviceId);
  
  return deviceId;
}

// Simple UUID generator
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// For debugging - clear device ID
export function clearDeviceId() {
  localStorage.removeItem('gigrequest_device_id');
}